import PropTypes from "prop-types";
import React from "react";

import { batch } from 'react-redux';
import { connect } from '~/redux/connect';
import { settingsActionCreator } from "~/actions/settingsActions";
import { getCalendar } from "~/stateGetter";
import { modelActionsCreator } from "~/actions/model_actions";
import { Button, Tooltip, MenuItem } from "~/native-ui"
import { withResponsiveFlags } from "../../hoc/withResponsiveProps";

class TableToggle extends React.Component {
    static propTypes = {
        isCalendarEnabled: PropTypes.bool,
        toggleCalendarView: PropTypes.func.isRequired,
        trans: PropTypes.func.isRequired,
        mode: PropTypes.oneOf(["menuitem", "button"]),
        onPress: PropTypes.func,
    }
    
    static defaultProps = {
        view: "list",
    }


    toggle = () => {
        const { filter_name } = this.props.calendarView;
        this.props.toggleCalendarView({ isCalendarEnabled: !this.props.isCalendarEnabled, filterName: filter_name });
        this.props.onPress?.();
    }

    renderToggleButton() {
        const { title } = this.props.calendarView;

        if (this.props.mode === 'menuitem') return (
            <MenuItem
                icon='event'
                caption={title}
                onClick={this.toggle}
                iconColor={"primary.500"}
            />
        )

        return (
            <Tooltip tooltip={title}>
                <Button
                    onPress={this.toggle}
                    icon="event"
                    iconSize="sm"
                    primary
                    ml="2"
                    ghost={ this.props.isCalendarEnabled }
                    {...this.props.buttonProps}
                />
            </Tooltip>
        )
    }

    render() {
        if (!this.props.hasCalendarViews) {
            return null
        }


        return this.renderToggleButton()
    };
}

export default connect(
    (state, { modelId }) => {
        return {
            ...getCalendar(state, modelId)
        }
    },
    (dispatch, { modelId }) => {
        const modelActions = modelActionsCreator(modelId),
              settingActions = settingsActionCreator(modelId);

        return {
            toggleCalendarView: ({filterName, isCalendarEnabled}) => {
                batch(() => {
                    dispatch(settingActions.toggleCalendarView(isCalendarEnabled))

                    if (isCalendarEnabled) { return; }
                    dispatch(settingActions.resetFieldValue(filterName, { created_at: null }))
                })
            }
        }
    }
)(TableToggle)